import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Cell } from "../grid/Cell";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-middle bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div>
                <div className="text-center">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    Cómo jugar
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                    Adivina la palabra en 6 intentos. Cada intento debe ser una palabra válida de 5 letras, 
      y los colores de las fichas se actualizarán para indicar qué tan cerca estás de la palabra correcta.
                    </p>

                    <div className="flex justify-center mb-1 mt-4">
                      <Cell value="J" status="correct" />
                      <Cell value="U" />
                      <Cell value="E" />
                      <Cell value="G" />
                      <Cell value="O" />
                    </div>
                    <p className="text-sm text-gray-500">
                    La letra J está en la palabra y en el lugar correcto.
                    </p>

                    <div className="flex justify-center mb-1 mt-4">
                      <Cell value="P" />
                      <Cell value="A" status="present" />
                      <Cell value="L" />
                      <Cell value="A" />
                      <Cell value="S" />
                    </div>
                    <p className="text-sm text-gray-500">
                    La letra L está en la palabra pero en el lugar equivocado.
                    </p>

                    <div className="flex justify-center mb-1 mt-4">
                      <Cell value="A" />
                      <Cell value="D" />
                      <Cell value="I" />
                      <Cell value="V" status="absent" />
                      <Cell value="A" />
                    </div>
                    <p className="text-sm text-gray-500">
                    La letra V no está en la palabra en ningún lugar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
